<template>
    <div id="login_id" class="login" v-wechat-title="userType.webSiteTitle"
         :class="{'login_style_1': userType.clientId === '100100',
         'login_style_2': userType.clientId === '100120',}">
      <div class="login_box">
        <!--<p>Lnshop</p>-->
        <!--登录页-->
        <img v-if="userType.clientId === '100120'" class="mauto bl" src="../../assets/img/s-speed.png"/>
        <p v-if="userType.clientId === '100120'" class="fs14 text_center fwb" style=" color: #dd2218;">{{userType.webUrl}}</p>
        <div v-if="showType === 'login'" class="login_msg">
          <div v-if="userType.clientId === '100100'" class="login_box_left">
            <div class="mt30 w140 mauto">
              <img v-if="userType.clientId === '100100'" class="w_percent100" src="../../assets/img/logo-03.png"/>
            </div>
            <p v-if="userType.clientId === '100100'" class="mt15 mb5 ml50 fs14 text_left">{{userType.webUrl}}</p>
            <p v-if="userType.clientId === '100100'" class="ml50 fs14 text_left">{{userType.companyName}}</p>
          </div>
          <div class="login_box_right">
            <ul v-if="userType.supplyWebUrl">
              <li class="mr30"><input id="proxy" class="mr5" name="loginType" type="radio" value="proxy" v-model="loginType" @click="loginType = 'proxy'"><label for="proxy">分销商</label></li>
              <li><input id="supplier" class="mr5" name="loginType" type="radio" value="supplier" v-model="loginType" @click="goSupplier()"><label for="supplier">供应商</label></li>
            </ul>
            <div class="login_box_right_account mt30">
              <span>账号：</span>
              <div>
                <i class="iconfont icon-user"></i>
                <input type="text" title="账号输入" maxlength="20" v-model.trim="loginName" @keyup="verifityLogin('loginNameWarn')" @keyup.enter="loginBtn()">
              </div>
            </div>
            <div class="login_box_right_account mt15">
              <span>密码：</span>
              <div>
                <i class="iconfont icon-pwd"></i>
                <input type="password" title="密码输入" v-model.trim="loginPwd" @keyup="verifityLogin('loginPwdWarn')" @keyup.enter="loginBtn()">
              </div>
            </div>
            <p class="h20 mt10 mb5 fcDel">{{loginWarn}}</p>
            <div class="login_box_right_account mb15">
              <button class="btn btn_normal" v-if="loginName && loginPwd" @click="loginBtn()">登 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;录</button>
              <button class="btn btn_normal forbid" v-if="!loginName || !loginPwd">登 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;录</button>
            </div>
            <div>
              <a @click="toForgetPwd()" class="mr15" title="只有超级管理员账号能找回">忘记密码？</a>
              <a @click="toRegister()" class="mr15">新用户注册</a>
              <a v-if="userType.clientId === '100100'" :href="'tencent://message/?uin=' + userType.customerServiceQQ + '&Site=&Menu-=yes'">联系客服</a><!--30519515-->
              <a v-if="userType.clientId === '100120'" :href="'tencent://message/?uin=' + userType.customerServiceQQ + '&Site=&Menu-=yes'">客服QQ</a><!--275561093-->
            </div>
          </div>
        </div>
        <!--注册页-->
        <register v-if="showType === 'register'" :registerType="loginType" @goBack="getRegister"></register>
        <!--忘记密码-->
        <forget-password v-if="showType === 'forgetPwd'" :numType="loginType" @goBack="getForgetPwd"></forget-password>
        <!--弹出框-->
        <alert-dialog v-if="showType === 'alertSuc'" :show-msg="showMsg" @confirm="confirmBtn"></alert-dialog>
        <!--<p>Copyright ©2016 厦门畅跑体育用品有限公司 版权所有 All Rights Reserved. </p>-->
        <!--<p>闽ICP备16028185号-1</p>-->
        <p class="mt20">Copyright ©2016 厦门畅跑体育用品有限公司 版权所有 All Rights Reserved. </p>
        <p> <a style="color:#ffffff" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">闽ICP备19012503号-1</a></p>
      </div>

      <!--加载框-->
      <loading-dialog v-if="isLoading" :type="'NOP'"></loading-dialog>
    </div>
</template>

<script type="es6">
import Register from '../register/register';
import ForgetPassword from '../forget-password/forget-password';
import AlertDialog from '../public-component/alert-dialog';
import LoadingDialog from '../public-component/loading-dialog';
// import Qs from 'qs';

export default {
  name: 'login',
  components: {Register, ForgetPassword, AlertDialog, LoadingDialog},
  beforeRouteLeave(to, from, next) {
    next();
    // location.reload();
  },
  data () {
    return {
      userType: {
        companyName: '',
        webUrl: '',
        customerServiceQQ: '',
        supplyWebUrl: '',
        webSiteTitle: '',
        webLogoName: '',
        financeQQ: '',
        clientId: ''
      },  // 用户类型
      // loginStyle: 2,  // 登录风格
      // clientId: '100120',  // 100100（阿木）  100120（客户）
      spUrl: '', // 供应商登录地址
      loginType: 'proxy', // proxy=分销商    supplier=供应商
      showType: 'login', // 显示类型 login=登录    register=注册    forgetPwd=忘记密码    alertSuc=成功对话框
      // loginName: 'sdfx', // 登录名
      loginName: '', // 登录名
      // loginPwd: '123456', // 登录密码
      loginPwd: '', // 登录密码
      loginWarn: '', // 登录错误警示判断
      isError: false, // 是否显示错误提示
      ychToken: null,
      showError: '', // 登录错误
      showMsg: '', // 弹出框显示内容
      isLoading: false // 是否显示加载框
    }
  },
  methods: {
    goSupplier() {
      // window.location.href = 'http://59.42.10.82:8006/Login/Index';
      // window.location.href = 'http://localhost:8141/Login/Index#';
      // window.location.href = 'http://59.42.10.82:8016/Login/Index#';
      // window.location.href = 'http://192.168.0.32:8102/Login/Index#';
      // window.location.href = this.spUrl + '/Login/Index#';
      window.location.href = this.userType.supplyWebUrl;
    },

    // 获取分销网站的客户个性化信息
    getWebClienData() {
      this.$axios.get(this.Global.getWebClienData).then((res) => {
        if (res && !res.data.errorMsg.length) {
          this.userType = res.data.resData;
          // this.userType['clientId'] = '100120';
        }
      });
    },

    // 验证登录信息
    verifityLogin (type) {
      switch (type) {
        case 'loginNameWarn':
          if (!this.loginName) {
            this.loginWarn = '用户不能为空';
          } else {
            this.loginWarn = '';
          }
          break;
        case 'loginPwdWarn':
          if (!this.loginPwd) {
            this.loginWarn = '密码不能为空';
          } else {
            this.loginWarn = '';
          }
          break;
      }
    },

    // 注册
    toRegister() {
      this.$router.push({
        path: '/login',
        query: {
          loginType: 'proxy',
          types: 'register'
        }
      });
      this.showType = 'register';
    },

    // 忘记密码
    toForgetPwd() {
      this.$router.push({
        path: '/login',
        query: {
          loginType: 'proxy',
          types: 'forgetPwd'
        }
      });
      this.showType = 'forgetPwd';
    },

    // 登录提交
    loginBtn () {
      this.verifityLogin('loginNameWarn');
      this.verifityLogin('loginPwdWarn');
      if (this.loginName && this.loginPwd) {
        this.isLoading = true;
        this.loginWarn = '';
        this.loginWarn = '';
        // this.setCookie(this.loginName, this.loginPwd, 7);
        // userName=pxadmin    sysType为账号类型，1=平台端账号  2=供应端账号  3=分销商端账号
        let sysType;
        if (this.loginType === 'supplier') { // 供应商
          sysType = 2;
          // window.location.href = 'http://59.42.10.82:8006/Login/Index?loginName=' + this.loginName + '&pwd=' + this.loginPwd;
          window.location.href = 'http://59.42.10.82:8016/Login/Index#';
        } else if (this.loginType === 'proxy') { // 分销商
          sysType = 3;
          const params = {
            loginName: this.loginName,
            pwd: this.loginPwd,
            sysType: sysType,
            ychToken: this.ychToken,
            ati: this.$cookies.get('_ati')
          };
          // 登录配置头部
          const header = {
            headers: {
              // 'Content-Type': 'application/x-www-form-urlencoded'
              'Content-Type': 'application/json'
            }
          };
          this.$axios.post(this.Global.loginUrl, JSON.stringify(params), header).then((res) => {
            if (!res.data.errorMsg.length) {
              if (res.data.redirectURL) {
                window.open(res.data.redirectURL, '_self');
                return;
              }
              sessionStorage.setItem('loginTimeout', 'false');
              sessionStorage.setItem('isRefresh', 'false'); // 判断是刷新UserId页面还是从tabs点击进入
              // sessionStorage.setItem('token', res.data.accessToken);
              sessionStorage.setItem('tabs', null);
              sessionStorage.setItem('tabsPosition', null);
              this.$store.commit('updateTabs', []);
              this.$store.commit('updateTabsPosition', '');
              sessionStorage.setItem('userId', res.data.sessionKey.UserId);
              sessionStorage.setItem('userName', res.data.sessionKey.UserName);
              sessionStorage.setItem('carGoodsList', null); // 清空购物车
              sessionStorage.setItem('refundCountInfo', JSON.stringify({
                pendingCount: 0,
                rejectCount: 0,
                waitingExchangeCount: 0
              })); // 售后单类型统计

              // 根据store中setToken方法将token保存至localStorage/sessionStorage中，data["Authentication-Token"]，获取token的value值
              this.$store.commit('setToken', res.data.accessToken);

              this.$axios.get(this.Global.getShoppingCartData).then((res) => {
                if (!res.data.errorMsg.length) {
                  this.$store.commit('addCarGoods', res.data.resData);
                  return this.$store.state.carGoodsList;
                }
              });
            }
            let timer;
            const self = this;
            timer = setTimeout(function () {
              clearTimeout(timer);
              if (res) {
                if (!res.data.errorMsg.length) {
                  self.$router.push({
                    path: '/home/index'
                  });
                } else {
                  self.isLoading = false;
                  self.loginWarn = res.data.errorMsg;
                }
              } else {
                self.isLoading = false;
              }
            }, 1000);
          });
        }
      }
    },

    // 接收注册页面传过来的返回数据
    getRegister(e) {
      // this.loginType = e.registerType;
      this.loginType = 'proxy';
      this.showType = e.showType;
      this.showMsg = '账号注册成功。平台方将尽快为您进行账户审核，审核结果会以短信形式进行通知，请您保持手机畅通！';
    },

    // 接收忘记密码页面传过来的返回数据
    getForgetPwd(e) {
      this.showType = e.showType;
      this.showMsg = '密码修改成功，请采用新的密码进行账户登录！';
    },

    // 接收成功弹出框传过来的返回数据
    confirmBtn(e) {
      console.log(e);
      this.showType = e.showType;
    },

    // 应用获取token —— 淘宝
    getToken(typeName, stateId, code) {
      this.$axios.get(this.Global.getToken(typeName, stateId, code)).then((res) => {
        if (res.data.errorMsg.length) {
          alert(res.data.errorMsg);
        }
      });
    },

    // 设置cookie
    setCookie (cName, cPwd, exDays) {
      let exdate = new Date(); // 获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exDays); // 保存的天数
      // 字符串拼接cookie
      window.document.cookie = 'userName=' + cName + ';path=/;expires=' + exdate.toGMTString();
      window.document.cookie = 'userPwd=' + cPwd + ';path=/;expires=' + exdate.toGMTString();
    },

    // 读取cookie
    getCookie () {
      if (document.cookie.length > 0) {
        const arr = document.cookie.split(';'); // 这里显示的格式切割
        for (let i = 0; i < arr.length; i++) {
          const arr2 = arr[i].split('='); // 再次切割
          // 判断查找相对应的值
          if (arr2[0] === 'userName') {
            this.loginName = arr2[1]; // 保存到保存数据的地方
            this.rmbPwd = true;
          } else if (arr2[0] === ' userPwd') {
            this.loginPwd = arr2[1];
          }
        }
      }
    },

    // 清除cookie
    clearCookie () {
      this.setCookie('', '', -1); // 修改2值都为空，天数为负1天就好了
    },

    // 邮箱正则表达式
    checkEmail (email) {
      const re = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
      return !!(email && re.test(email));
     /* if (email && re.test(email)) {
        return true;
      } else {
        return false;
      } */
    },

    // 找回密码
    forgetPwd () {
      this.$router.push({
        path: '/f-pwd'
      })
    }
  },
  created () {
    console.log(9999, this.$route);
    console.log(8888,  this.$route.query['code']);
    console.log('窗口url', window.location.href);
    console.log('窗口主机名', window.location.host);
    console.log('窗口端口', window.location.port);
    console.log('窗口路径', window.location.pathname);
    console.log('窗口参数', window.location.search);
    console.log('窗口参数code下标', window.location.search.indexOf('code'));
    console.log('窗口参数&state下标', window.location.search.indexOf('&state'));
    console.log('窗口参数code参数的截取', window.location.search.substring(window.location.search.indexOf('code=') + 5, window.location.search.indexOf('&state')));
    console.log('地址', window.location.href.split('?')[1]);
    console.log('地址后面的', window.location.href.split('?')[1]);
    // console.log('地址后面的', this.$route.query['type']);
    // 订购回调的参数
    if (this.$route.query['typename']) {
      if (this.$route.query['typename'] === 'ych') {  // 这里是御城河第二次验证后返回的token值
        this.ychToken = this.$route.query['token'];
      } else if (this.$route.query['typename'] === 'tb') {  // 这里是淘宝订购
        this.getToken(this.$route.query['typename'], this.$route.query['state'], this.$route.query['code']);
      }
    }

    // 这里是御城河第二次验证后返回的token值
    // if (this.$route.query['token']) {
    //   this.ychToken = this.$route.query['token'];
    // }

    this.getWebClienData();

    /* 获取供应商部署地址 */
    this.$axios.get(this.Global.getSPUrl).then((res) => {
      this.spUrl = res.data.resData;
    });

    if (this.$route.query['loginType']) {
      this.loginType = this.$route.query['loginType'];
    }
    if (this.$route.query['types']) {
      this.showType = this.$route.query['types'];
    }

    // 不能直接将事件添加写在input上，因为这样必须焦点在input上才能触发，所以可以直接绑定在document上即可
    let self = this;
    document.onkeydown = function () {
      if (window.event.keyCode === 13) {
        self.loginBtn();
      }
    }
  },
  destroyed() { // 离开此组件执行方法
    document.onkeydown = function () {
      if (window.event.keyCode === 13) {
        // self.loginBtn();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/css/style";
  @import "../../assets/css/base-color";

.login {
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;

  .login_box {
    font-size: 14px;

    &>p {
      color: #fff;
      text-align: center;

      &:first-child {
        padding: 20px 0;
        font-size: 36px;
      }
    }

    .login_msg {
      margin: auto;
      width: 650px;
      /* min-width: 430px; */
      height: 210px;
      text-align: center;
      background-color: #fff;
      border-radius: 10px 10px;
      box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.35);
      padding: 50px 10px 30px; /* 第二版login_box_left样式 */
      font-size: 12px;
      /*background-color: rgba(83, 115, 150, 0.4);*/
      border: 1px solid #ddd;
      /*color: #d2d2d2;*/
      /*color: #504f4d;*/

      .el-alert.pa.pl10.h40.el-alert--error {
        margin-top: -46px;
      }

      a {
        /*color: #d2d2d2;*/
        /*color: #504f4d;*/
      }

      .login_box_left {
        display: inline-block;
        float: left;
        width: 240px;
        height: 100%;
        border-right: 1px solid;
      }

      .login_box_right {
        display: inline-block;

        ul {
          height: 20px;
          text-align: center;
          font-size: 16px;

          li {
            display: inline-block;

            input[type='radio']:hover, label:hover {
              cursor: pointer;
            }
          }
        }

        .login_box_right_account {
          width: 268px;
          height: 28px;

          div {
            display: inline-block;
            position: relative;
            width: 200px;

            input[type='text'], input[type='password'] {
              padding-left: 25px;
              height: 26px;
            }

            .iconfont {
              position: absolute;
              top: 6px;
              left: 6px;
            }
          }

          button {
            width: 215px;
            float: right;
            padding: 6px;
            font-size: 12px;
            border-radius: 6px;
            border: 1px solid #8ba6c6;
          }
        }

      }

      /*第一版*/
      .login_tabs {
        border-bottom: 1px solid $bgC;

        ul {
          width: 97%;
          display: inline-block;
          margin-bottom: -3px;

          li {
            display: inline-block;
            float: left;
            width: 33%;
            padding: 10px 0;

            &:hover {
              cursor: pointer;
              color: $loginColor;
            }

            &.active {
              color: $loginColor;
              border-bottom: 1px solid $loginColor;
            }
          }
        }
      }

    }

    .login_content {
      &>div {
        width: 70%;
        margin: 25px auto;

        &>p {
          text-align: left;
          margin-bottom: 5px;

          &.warn {
            color: #ff0000;
            margin-top: 5px;
          }

          .iconfont {
            margin-left: 5px;
            margin-right: 10px;
            font-size: 18px;
            color: #999999;
          }
        }

        &>input {
          border-radius: 10px;
          /* box-shadow: 0 0 5px rgba(0, 0, 0, 0.35); */
        }
      }

      .login_btn {
        button {
          width: 100%;
          height: 40px;
          line-height: 40px;
          border: none;
          border-radius: 10px;
          background-color: rgba(22, 155, 213, 1);
          font-size: 16px;
          color: #ffffff;

          &:hover {
            cursor: pointer;
            background-color: rgba(22, 155, 213, 0.8);
          }

          &.forbid {
            background-color: rgba(22, 155, 213, 0.8);

            &:hover {
              cursor: no-drop;
            }
          }
        }
      }

      .login_bottom {
        width: 100%;
        text-align: right;

        a {
          display: inline-block;
          color: $loginColor;
          margin-right: 15px;
          margin-bottom: 10px;

          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }

  &.login_style_1 {
    background: url("../../assets/img/bg_login.jpg") no-repeat fixed;
    background-size: cover;

    .login_box {
      .login_msg {
        background-color: rgba(45, 61, 78, 0.4);
        color: #d2d2d2;

        .login_box_right {
          button {
            background: linear-gradient(180deg,#527fad, #35649f);
          }
        }

        a {
          color: #d2d2d2;
        }
      }
    }

  }

  &.login_style_2 {
    background: url("../../assets/img/login_bg_10.jpg") no-repeat fixed;
    background-size: 100% 100%;
    position: relative;

    & > img {
      position: absolute;
      top: 40px;
      left: 35px;
    }

    .login_box {
      .login_msg {
        background-color: rgba(255, 255, 255, 0.4);
        color: #504f4d;

        .login_box_left {
          & > div {
            width: 100%;
            margin: 0;
            height: 100%;
            overflow: hidden;

            img {
              width: 80%;
              margin-top: 65px;
              /*width: 155%;
              margin-left: -65px;
              margin-top: -65px;*/
            }
          }
        }

        .login_box_right {

          button {
            background: linear-gradient(180deg, #dadada, #1d58a2);
          }
        }

        a {
          color: #504f4d;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue